// pairingAPI.js
import { fetchWithAuth } from "@/api/fetchApi";

// ✅ ペアリングコード送信 (POST /api/pairing/complete/)
export async function submitPairingCode(code) {
  try {
    const response = await fetchWithAuth("/pairing/complete/", {
      method: "POST",
      body: JSON.stringify({ code }),
    });

    // 正常レスポンス（例: { status: "waiting" } or { status: "paired" }）
    return response;
  } catch (err) {
    console.error("❌ submitPairingCode failed", err);

    // 明示的にエラー構造を返す
    return { status: "error", error: err.message || "Unknown error" };
  }
}

// ✅ ペアリングステータス確認 (GET /api/pairing/status/?code=xxxxx)
export async function checkPairingStatus(code) {
  try {
    const res = await fetchWithAuth(`/pairing/status/?code=${code}`, {
      method: "GET",
    });
    return res; // { status: "waiting" | "paired" | "expired", email: "..." }
  } catch (err) {
    console.error("❌ checkPairingStatus failed", err);
    return null;
  }
}

// ✅ Unity側: ペアリング開始登録 (POST /api/pairing/wait/)
export async function initiatePairing(code) {
  try {
    const res = await fetchWithAuth("/pairing/wait/", {
      method: "POST",
      body: JSON.stringify({ code }),
    });
    return res; // { status: "waiting" }
  } catch (err) {
    console.error("❌ initiatePairing failed", err);
    return null;
  }
}
